import { render, staticRenderFns } from "./GameBadges.vue?vue&type=template&id=90847b80&scoped=true"
import script from "./GameBadges.vue?vue&type=script&lang=ts"
export * from "./GameBadges.vue?vue&type=script&lang=ts"
import style0 from "./GameBadges.vue?vue&type=style&index=0&id=90847b80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90847b80",
  null
  
)

export default component.exports